import type { GridFilterFormProps } from '@mui/x-data-grid';
import { SearchableFilterColumnSelect } from './SearchableFilterColumnSelect';

type SearchableFilterFormProps = Pick<
  GridFilterFormProps,
  'columnInputProps' | 'valueInputProps'
>;

export function getSearchableFilterFormProps(): SearchableFilterFormProps {
  return {
    columnInputProps: { as: SearchableFilterColumnSelect },
    valueInputProps: {
      InputComponentProps: {
        variant: 'outlined',
        size: 'small',
        fullWidth: true,
      },
    },
  };
}
